<template>
  <div>
    相关电影
  </div>
</template>

<script>
export default {
  name: 'MovieRelated'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pc/pages/movie/MovieRelated.vue